import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken, getBidderId } from '@/redux/modules/account/user/user.selectors';
import { getDeployment } from '@/redux/modules/config';
import { PageTrackingData } from './analytics.types';
import { postTrackPageView } from './analytics.api';

export const trackPageView = createAsyncThunk<void, Omit<PageTrackingData, 'bidderId' | 'path'>>(
    'la/ui/analytics/recordPageView',
    async ({ catalogId, itemId }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const bidderId = getBidderId(state);

        await postTrackPageView({
            authToken,
            bidderId,
            catalogId: catalogId || 0,
            deployment,
            itemId: itemId || 0,
            path: window.location.pathname,
        });
    }
);
